<template>
  <div
    v-if="stageList.length > 0"
    class="phase-operation-simple"
    :style="module.containerStyle"
    :data-tangram-module-id="module.id"
    @click="handleClick"
  >
    <div
      v-for="(data, index) in stageList"
      :key="index"
      :class="['stage-item', data.stageStatus === 1 ? 'has-receive' : '']"
    >
      <div class="name">{{ data.stageName }}</div>
      <div class="msg">
        <p class="num">
          <span class="symbol">¥</span>
          <span class="value">{{ data.totalAmount }}</span>
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import { cmsRedirect } from '@/common/cms/cms_redirect'
import { toChinesNum } from '@/utils/math'
export default {
  name: 'PhaseOperationsSimple',
  props: {
    module: {
      type: Object,
      default: () => {}
    }
  },
  computed: {
    stageList() {
      const stageList = (this.module.data?.stageList || []).map(
        (item, index) => {
          const name = toChinesNum(index + 1)
          item.stageName = `任务${name}`
          return item
        }
      )
      return stageList || []
    }
  },
  methods: {
    handleClick() {
      const { action, tickerInfo } = this.module.data
      if (tickerInfo?.click) {
        this.$track(
          tickerInfo.click.spm,
          Object.assign({}, tickerInfo.click.spmJson, tickerInfo?.data)
        )
      }
      cmsRedirect(action)
    }
  }
}
</script>

<style lang="scss" scoped>
.phase-operation-simple {
  overflow-x: auto;

  @include flex(row, flex-start, center, nowrap);
  .stage-item {
    display: flex;

    position: relative;

    min-width: 1.92rem;
    height: 1.64rem;
    margin-right: 0.6rem;

    background-image: url('../images/stage_will_get.png');
    background-repeat: no-repeat;
    background-size: 100% 100%;

    flex-direction: column;

    &::after {
      position: absolute;
      top: 0.68rem;
      right: -0.44rem;

      width: 0.28rem;
      height: 0.28rem;

      background-image: url('../images/stag_space.png');
      background-repeat: no-repeat;
      background-size: 100% 100%;

      content: '';
    }

    &:last-child {
      margin-right: 0;
      &::after {
        display: none;
      }
    }

    .name {
      padding-top: 0.04rem;

      font-size: 0.2rem;
      font-weight: 500;
      text-align: center;
      color: #80350f;
    }

    .msg {
      margin-top: 0.16rem;

      @include flex(row, center);
      .num {
        color: #ffe6a5;

        .symbol {
          font-size: 16px;
          font-weight: $fw-regular;
        }

        .value {
          font-size: 24px;
          font-weight: $fw-bold;
        }
      }
    }
    &.has-receive {
      background-image: url('../images/stage_get.png');
      .msg {
        .num {
          color: #f03100;
        }
      }
    }
  }
}
</style>
